import { render, staticRenderFns } from "./ComfirmDialog.vue?vue&type=template&id=2a8b4b0c&scoped=true&"
import script from "./ComfirmDialog.vue?vue&type=script&lang=js&"
export * from "./ComfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./ComfirmDialog.vue?vue&type=style&index=0&id=2a8b4b0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b4b0c",
  null
  
)

export default component.exports